// Side-effect import: configures Amplify from the Gen2 amplify_outputs.json.
// MUST be first — before AuthContainer/store or anything that touches
// Amplify/Auth — otherwise Amplify.configure() never runs and sign-in throws
// "Auth UserPool not configured".
import "./config/initAmplify";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import { AuthContainer } from "./AuthContainer";

import { Provider, rootStore } from "./store/root";
import "./index.css";
import "./index.scss";
import { CSInterface } from "csinterface-ts";
import { getEnvironmentDetector, getServerIdForCurrentEnvironment } from "./utils/environmentDetector";
// const environment = process.env.REACT_APP_HOST_TYPE === 'staging' ? 'production':  process.env.REACT_APP_HOST_TYPE || 'development';

const { csInterface }: { csInterface: CSInterface | undefined } = window as any;

export const CsInterfaceContext = React.createContext(csInterface);

function initializeServer() {
  console.log("initializeServer");
  
  // Only initialize if running inside After Effects (csInterface exists and has methods)
  if (!csInterface || typeof csInterface.getExtensionID !== 'function') {
    console.log("Not running in After Effects or CSInterface not ready, skipping server initialization");
    return;
  }
  
  try {
    // Get the environment detector instance
    const envDetector = getEnvironmentDetector(csInterface);
    const serverId = envDetector.getServerId();
    const environment = envDetector.getEnvironment();
    const config = envDetector.getCurrentConfig();
    
    console.log(`Initializing server for environment: ${environment}`);
    console.log(`Using server ID: ${serverId}`);
    console.log(`Environment config:`, config);
    
    // Request the correct server extension for the current environment
    csInterface.requestOpenExtension(serverId, "");
    console.log("Server initialization complete");
  } catch (error) {
    console.error("Error during server initialization:", error);
  }
}
initializeServer();

// Amplify is already configured for Gen2 by the `./config/initAmplify` import
// at the top of this file (runs on every load/reload, including after the SAML
// websocket flow stores its session and reloads).
ReactDOM.render(
  <React.StrictMode>
    <Provider value={rootStore}>
      <AuthContainer />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
